import { render, staticRenderFns } from "./debtManagement.vue?vue&type=template&id=3a971c54&scoped=true&"
import script from "./debtManagement.vue?vue&type=script&lang=js&"
export * from "./debtManagement.vue?vue&type=script&lang=js&"
import style0 from "./debtManagement.vue?vue&type=style&index=0&id=3a971c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a971c54",
  null
  
)

export default component.exports